import clsx from 'clsx';
import { MenuItem } from '../../hooks/use-menu-items';
import styles from '../main-menu-desktop/main-menu-desktop.module.css';

const isRouteActive = (item: MenuItem, activeMenuItem: MenuItem | undefined) => {
  return activeMenuItem === item;
};

export const getLabelStyles = (item: MenuItem, activeMenuItem: MenuItem | undefined) => {
  return clsx(styles.textName, { [styles.activeText]: isRouteActive(item, activeMenuItem) });
};

export const getIconStyles = (item: MenuItem, activeMenuItem: MenuItem | undefined) => {
  return { [styles.activeMenuItem]: isRouteActive(item, activeMenuItem) };
};
